import FormHelperText from '@mui/material/FormHelperText';
import { useMaterialUIController } from 'context';
import PropTypes from 'prop-types';

/**
 * FormFieldHelperText
 * @param {String} helperText
 * @returns FormHelperText element
 */

const propTypes = {
  helperText: PropTypes.string,
};

const FormFieldHelperText = ({ helperText }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const color = darkMode ? 'white' : 'grey';
  return <FormHelperText style={{ color: color }}>{helperText}</FormHelperText>;
};

FormFieldHelperText.propTypes = propTypes;

export default FormFieldHelperText;
